import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const mobile = '@media (max-width: 768px)'
const font = '"Segoe UI", Arial'

const containerBase = css`
  width: 1180px;
  margin: 0 auto;
  padding: 80px 10px 0;
  position: relative;

  ${mobile} {
    width: 100%;
    padding: 40px 16px 0;
  }
`

const flexCol = css`
  display: flex;
  flex-direction: column;
`

export const Container = styled.section`
  ${containerBase}
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  position: relative;

  ${mobile} {
    justify-content: center;
  }
`

export const Bg = styled.div`
  left: -65px;
  top: 0;
  position: absolute;

  svg {
    width: 450px;
    height: 390px;
  }

  ${mobile} {
    display: none;
  }
`

export const Content = styled.div`
  ${flexCol}
  width: 655px;

  ${mobile} {
    width: 100%;
  }
`

export const Title = styled.h2`
  font-size: 35px;
  font-family: ${font};
  font-weight: 400;
  color: #78be20;
  display: flex;
  margin-bottom: 30px;

  span {
    font-weight: 800;
    margin-right: 10px;
  }

  ${mobile} {
    font-size: 28px;
    flex-wrap: wrap;
  }
`

export const InfoContainer = styled.div`
  ${flexCol}
  gap: 20px;

  p {
    font-size: 18px;
    line-height: 27px;
  }

  ${mobile} {
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const InfoMore = styled.div`
  border: 2px solid #eeeef0;
  padding: 30px 25px;
  border-radius: 15px;
  margin-top: 30px;
  display: flex;
  gap: 25px;
  align-items: center;

  p {
    font-size: 18px;
    line-height: 27px;
    width: 580px;
  }

  ${mobile} {
    flex-direction: column;
    align-items: flex-start;

    p {
      width: 100%;
      font-size: 16px;
      line-height: 24px;
    }
  }
`
